import { useNavigate } from "react-router-dom";
import { fetchConversations } from "../lib/api";
import { useApi } from "../hooks/use-api";
import { useDocumentTitle } from "../hooks/use-document-title";

function titleCase(str: string): string {
  return str.replace(/\b\w/g, (c) => c.toUpperCase());
}

function stateBadgeClass(state: string): string {
  switch (state) {
    case "support_escalated":
    case "support_active":
      return "badge badge-warning";
    case "bid_confirming":
      return "badge badge-info";
    case "idle":
      return "badge badge-neutral";
    default:
      return "badge badge-neutral";
  }
}

export function ConversationsPage() {
  useDocumentTitle("Conversations");
  const { data, loading, error, refetch } = useApi(fetchConversations);
  const navigate = useNavigate();

  return (
    <>
      <div className="card-header">
        <h1 className="page-title">Conversations</h1>
        <button className="btn btn-sm" type="button" onClick={refetch}>
          Refresh
        </button>
      </div>

      {loading && <div className="loading">Loading conversations...</div>}
      {error && <div className="error-msg">{error}</div>}

      {data && data.length === 0 && <div className="empty-state">No conversations yet</div>}

      {data && data.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Dealer</th>
              <th>Channel</th>
              <th>State</th>
              <th>Last Message</th>
              <th>Updated</th>
            </tr>
          </thead>
          <tbody>
            {data
              .sort((a, b) => b.lastMessageAt.localeCompare(a.lastMessageAt))
              .map((conv) => (
                <tr
                  key={conv.conversationId}
                  className="clickable-row"
                  onClick={() => navigate(`/conversation/${conv.dealerId}`)}
                >
                  <td>
                    {conv.dealerName
                      ? `${titleCase(conv.dealerName)} (${titleCase(conv.dealerOrg ?? "—")})`
                      : `#${conv.dealerId}`}
                  </td>
                  <td>{conv.channel === "whatsapp" ? "WhatsApp" : conv.channel}</td>
                  <td>
                    <span className={stateBadgeClass(conv.state)}>{conv.state}</span>
                  </td>
                  <td className="mono">{new Date(conv.lastMessageAt).toLocaleString()}</td>
                  <td className="mono">{new Date(conv.updatedAt).toLocaleString()}</td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </>
  );
}
